import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CodeProjectIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "CodeProject",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M17.451 10.328a1.137 1.137 0 0 0-1.4.808L13.598 20.3a1.141 1.141 0 1 0 2.207.592l2.455-9.165a1.14 1.14 0 0 0-.808-1.4M22.522 12.905a1.144 1.144 0 0 0-1.617 1.617l1.551 1.55-1.55 1.55a1.143 1.143 0 0 0 1.615 1.616l2.359-2.357a1.14 1.14 0 0 0 0-1.617zM9.544 15.928l1.55-1.55a1.143 1.143 0 0 0-1.615-1.616L7.12 15.119a1.14 1.14 0 0 0 0 1.617l2.358 2.359a1.14 1.14 0 0 0 1.617 0 1.144 1.144 0 0 0 0-1.617z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M26.286 2.286H5.714a3.43 3.43 0 0 0-3.428 3.428v20.572a3.43 3.43 0 0 0 3.428 3.428h20.572a3.43 3.43 0 0 0 3.428-3.428V5.714a3.43 3.43 0 0 0-3.428-3.428m1.143 24c0 .63-.513 1.143-1.143 1.143H5.714c-.63 0-1.143-.513-1.143-1.143V5.714c0-.63.513-1.143 1.143-1.143h20.572c.63 0 1.143.513 1.143 1.143z"
    })]
  }));
};
CodeProjectIcon.displayName = 'CodeProjectIcon';